import type { State } from 'store/types';

export const selectFileUploads = (state: State) => state.fileUpload.uploads;

export const selectFileUpload = (state: State, uploadId: string) =>
  state.fileUpload.uploads.find((upload) => upload.uploadId === uploadId);
